module.exports = __webpack_public_path__ + "img/20@2x.ebdfa10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/20@2x.png
// module id = b8By
// module chunks = 0